import { Card } from "react-bootstrap";

export function EmptyState({ title, description, action }) {
  return (
    <Card className="empty-state">
      <Card.Body>
        <p className="empty-state-title">{title}</p>
        {description && <p className="empty-state-description">{description}</p>}
        {action && <div className="empty-state-action">{action}</div>}
      </Card.Body>
    </Card>
  );
}

export function EmptyRow({ colSpan, text }) {
  return (
    <tr>
      <td colSpan={colSpan} className="empty-row">
        {text}
      </td>
    </tr>
  );
}
